import ModalLinkController from "../../../../../javascript/stimulusControllers/modals/modal-link-controller";

export default class extends ModalLinkController {};



// WEBPACK FOOTER //
// ./app/components/associations/habtm/assets/javascript/associations-habtm-add-button-controller.js